import { render, staticRenderFns } from "./ViewStakeholder.vue?vue&type=template&id=1fe6a3db&scoped=true"
import script from "./ViewStakeholder.vue?vue&type=script&lang=js"
export * from "./ViewStakeholder.vue?vue&type=script&lang=js"
import style0 from "./ViewStakeholder.vue?vue&type=style&index=0&id=1fe6a3db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6a3db",
  null
  
)

export default component.exports